/**
 * Created by staffanrantzow on 05/04/16.
 */

import axios from 'axios';
import ProfessionEntity from './profession-entity';
import {APIResult} from '../http';

class ProfessionsService {

  hydrate (profession) {
    return new ProfessionEntity(
      profession.id,
      profession.attributes.insurance_status_id,
      profession.attributes.language_id,
      profession.attributes.ssyk,
      profession.attributes.title
    );
  }

  hydrateCollection (data) {
    var professions = [];

    for (let profession of data) {
      professions.push(this.hydrate(profession));
    }

    return professions;
  }

  getByTitle (title) {
    return axios.get('backend://professions?filter[title][*]=' + title)
      .then(
        (response) => {
          var professions = this.hydrateCollection(response.data.data);
          return new APIResult(professions, response.data.meta);
        }
      );
  }

  get () {
    return axios.get('backend://professions')
      .then(
        (response) => {
          var professions = this.hydrateCollection(response.data.data);
          return new APIResult(professions, response.data.meta);
        }
      );
  }

}

export default new ProfessionsService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/professions/professions-service.js
 **/